import Vue from 'vue'
import VueSocketio from 'vue-socket.io'
import io from 'socket.io-client'
import store from './../store'
import AppConfig from './config/AppConfig'

const GLOBAL_CONFIG = AppConfig.load()

const socketUrl = GLOBAL_CONFIG.SOCKET_SERVER.replace(/\/api\/?$/, '')

const socket = io(socketUrl, {
  path: '/socket.io',
  transports: ['polling', 'websocket'],
  reconnectionAttempts: 3,
  timeout: 5000,
  query: { token: localStorage.getItem('token') || '' },
})

socket.on('connect', () => {
  console.log(
    '%c[Socket] Conectado ✔',
    'color: #22c55e; font-weight: bold;',
    socket.id
  )
})
socket.on('disconnect', reason => {
  console.warn('[Socket] Desconectado:', reason)
})
socket.on('connect_error', err => {
  console.error('[Socket] Error de conexión:', err.message)
})

Vue.use(
  new VueSocketio({
    debug: false,
    connection: socket,
    vuex: {
      store,
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET_',
    },
  })
)
